import { Grid, Typography } from '@mui/material';
import { UserInvitation } from 'vendor-marketplace-shared-library';
import UserService from '../../../services/user.service';
import useAlert from '../../../hooks/useAlert';
import {
  CANCEL_USER_INVITATION,
  DELETE_USER_INVITATION,
  RESEND_USER_INVITATION,
} from '../../../error-messages';
import { useState } from 'react';
import UserInvitationCard from '../../../components/user/UserInvitationCard';

type UserInvitationsModuleProps = {
  userInvitations: UserInvitation[];
  refetchInvites: () => void;
};

export default function UserInvitationsModule(props: UserInvitationsModuleProps) {
  const alert = useAlert();
  // disabledUserInvitationIds timeout is handling rendering different states of the button
  const [disabledUserInvitationIds, setDisabledUserInvitationIds] = useState<string[]>([]);

  const onResendInvitation = async (userInvitationId: string) => {
    try {
      const response = await UserService.resendUserInvitation(parseInt(userInvitationId));
      const newUserInvitationId = response.data.userInvitationId.toString();
      setDisabledUserInvitationIds([...disabledUserInvitationIds, newUserInvitationId]);
      setTimeout(() => {
        setDisabledUserInvitationIds(
          disabledUserInvitationIds.filter(id => id !== newUserInvitationId),
        );
      }, 60000);
      await props.refetchInvites();
    } catch (error: any) {
      alert.setAlert({
        severity: 'error',
        message: error.response?.data?.error ?? RESEND_USER_INVITATION,
      });
    }
  };

  const onCancelInvitation = async (userInvitationId: string) => {
    try {
      await UserService.cancelUserInvitation(parseInt(userInvitationId));
      await props.refetchInvites();
    } catch (error: any) {
      alert.setAlert({
        severity: 'error',
        message: error.response?.data?.error ?? CANCEL_USER_INVITATION,
      });
    }
  };

  const onDeleteInvitation = async (userInvitationId: string) => {
    try {
      await UserService.deleteUserInvitation(parseInt(userInvitationId));
      await props.refetchInvites();
    } catch (error: any) {
      alert.setAlert({
        severity: 'error',
        message: error.response?.data?.error ?? DELETE_USER_INVITATION,
      });
    }
  };

  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item xs={12}>
        <Typography variant={'h6'}>User Invitations</Typography>
      </Grid>
      {props.userInvitations.map(userInvitation => (
        <Grid item key={userInvitation.id}>
          <UserInvitationCard
            userInvitation={userInvitation}
            disabledUserInvitationIds={disabledUserInvitationIds}
            onResendInvitation={onResendInvitation}
            onCancelInvitation={onCancelInvitation}
            onDeleteInvitation={onDeleteInvitation}
          />
        </Grid>
      ))}
    </Grid>
  );
}

const styles = {
  mainContainer: {
    backgroundColor: 'secondary.light',
    padding: 1,
    borderRadius: 2,
    rowGap: 2,
    columnGap: 2,
  },
};
